export default "__VITE_ASSET__DhHHgfZ2__"